import { FC, memo } from 'react';
import { AuctionTypeEnum } from '../../../../lib/utils/AuctionTypeEnum';
import { getNewDateWithOffset } from 'prembid-shared-library-npm/helpers';
import { CountdownRenderProps, zeroPad } from 'react-countdown';
import { Countdown } from "@/components/library/Countdown";
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/Store';
import { Skeleton } from '../../../dumb/Skeleton';
import Pill from '@/components/ui/Pill';

type CountdownTimerContainerProps = {
    showLoading?: boolean;
    auctionType: number | undefined;
    isActive: boolean | undefined;
    validating: boolean;
    isExtended: boolean;
    isWinning: boolean;
    profileId: any;
    start: Date | undefined;
    end: Date | undefined;
    now: Date;
    countDownTimer: any;
}

// Status pill, countdown text and winning/losing pill in one row, as in the mobile bid panel.
const CountdownTimerContainer: FC<CountdownTimerContainerProps> = ({ showLoading = false, auctionType, isActive, validating, isExtended, isWinning, profileId, start, end, now, countDownTimer }) => {

    const currentDateTimeOffset = useSelector((state: RootState) => state.settings.serverDateTimeDifference);

    if (showLoading) return <Skeleton animation="wave" variant="rectangular" height="48px" width="100%" />;

    const status =
        !isActive ? <Pill dot variant="solid" tone="dark" label="Unavailable" />
            : validating ? <Pill dot variant="solid" tone="dark" label="Validating" />
                : !!start && now < start ? <Pill dot variant="solid" tone="dark" label="Awaiting" />
                    : !!end && now > end ? <Pill dot variant="solid" tone="danger" label="Completed" />
                        : !!end && !!start && isExtended ? <Pill dot variant="solid" tone="warning" label="Extended" />
                            : !!end && !!start ? <Pill dot variant="solid" tone="success" label="Open" />
                                : null;

    const header = !!start && now < start ? "Starting in" : "Closing in";

    const renderer = ({ days, hours, minutes, seconds, completed }: CountdownRenderProps) =>
        <span>{completed ? "00d 00h 00m 00s" : `${zeroPad(days)}d ${zeroPad(hours)}h ${zeroPad(minutes)}m ${zeroPad(seconds)}s`}</span>;

    return (
        <div className="pb-bid-status">
            <div>{status}</div>
            <div className="pb-bid-countdown">
                <div className="pb-bid-countdown-label">{header}</div>
                <div className="pb-bid-countdown-value">
                    {countDownTimer?.countdownDate ? (
                        <Countdown
                            now={() => getNewDateWithOffset(currentDateTimeOffset).getTime()}
                            date={countDownTimer?.countdownDate}
                            renderer={renderer}
                        />
                    ) : "--d --h --m --s"}
                </div>
            </div>
            <div>
                {auctionType !== AuctionTypeEnum.Tender && profileId && (
                    isWinning ? <Pill dot tone="success" label="Winning" /> : <Pill dot tone="danger" label="Losing" />
                )}
            </div>
        </div>
    );
}

export default memo(CountdownTimerContainer);
